<template lang="html">
  <div class="_settings">
    <div class="container-fluid p-0">
      <div class="_settings__topcontent __wrapper_">
        <div class="dynamic-component-keep-alive-demo clearfix">
          <div class="button-group p-0">
            <div class="row">
              <button class="_settings__topcontent--tabs p-0" v-for="tab in tabs"
                v-bind:key="tab.id"
                v-bind:class="{ '_settings__topcontent--selected': selectedtabs === tab.content}"
                v-on:click="selectedtabs = tab.content">
                <p>{{ tab.title }}</p>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="_settings__mastercontent h-100">
        <keep-alive>
          <component v-bind:is="currentStepComponent"></component>
        </keep-alive>
      </div>
    </div>
  </div>  <!-- end class = settings -->
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import MyAccount from '@/components/settings/MyAccount'
import Documents from '@/components/settings/Documents'
import AccountUsers from '@/components/settings/AccountUsers'

export default {
  name: 'settings',
  components: {
    Sidebar,
    MyAccount,
    Documents,
    AccountUsers
  },
  data () {
    return {
      selectedtabs: MyAccount,
      selectedtab: 1,
      selectedfilter: 1,
      settingType: 'My Account',
      SidebaarSelectedMenu: 2,
      tabs: [
        {
          id: 1,
          title: 'My Account',
          content: MyAccount
        },
        {
          id: 2,
          title: 'Documents',
          content: Documents
        },
        {
          id: 3,
          title: 'Account Users',
          content: AccountUsers
        }
      ]
    }
  },
  computed: {
    currentStepComponent: function () {
      const self = this
      if (this.selectedtabs === MyAccount) {
        self.selectedtab = 1
        self.settingType = 'My Account'
      }
      if (this.selectedtabs === Documents) {
        self.selectedtab = 2
        self.settingType = 'Documents'
      }
      if (this.selectedtabs === AccountUsers) {
        self.selectedtab = 3
        self.settingType = 'Account Users'
      }
      return this.selectedtabs
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/Setting.vue